/** Nombre presentable de una persona (pf / pm / fideicomiso) para listas y detalles. */
export function nombrePersona(
  p: {
    tipo: string;
    nombre: string | null;
    apellido_paterno: string | null;
    apellido_materno: string | null;
    denominacion_razon: string | null;
    fiduciario_denominacion: string | null;
    fideicomiso_identificador: string | null;
  } | null,
): string {
  if (!p) return "(sin persona)";
  if (p.tipo === "pm") return p.denominacion_razon ?? "(sin razón social)";
  if (p.tipo === "fideicomiso") {
    return p.fideicomiso_identificador
      ? `Fideicomiso ${p.fideicomiso_identificador}`
      : (p.fiduciario_denominacion ?? "(fideicomiso)");
  }
  const partes = [p.nombre, p.apellido_paterno, p.apellido_materno].filter((x): x is string => !!x);
  return partes.length > 0 ? partes.join(" ") : "(sin nombre)";
}
